'use client';

/**Các key lưu vào local-storage */
export enum LocalStorageKeys {
    /**
     * Token
     */
    Token = 't0k3n',

    /**
     * EMP Info
     */
    EMP_Info = '3mp1nf0',

    /**
     * Session
     */
    Auth = '4uth',

    /**
     * Cache
     */
    Cache = 'c4ch3',

    /**
     * Locale
     */
    Locale = 'l0c4l3',
    /**
     * Cookie Version
     */
    App_Version = '4pp_v3r510n',
}

export function getLocalStorage(key: LocalStorageKeys) {
    if (typeof window !== 'undefined') {
        const _dt = localStorage.getItem(key);
        return _dt ? JSON.parse(_dt) : null;
    }
    return null;
}

export function setLocalStorage(key: LocalStorageKeys, value: string) {
    if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem(key, value);
    }
}

export function removeLocalStorage(key: LocalStorageKeys) {
    if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.removeItem(key);
    }
}
